import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=4d6feb4b&scoped=true&"
import script from "./dataStatistics.vue?vue&type=script&lang=js&"
export * from "./dataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./dataStatistics.vue?vue&type=style&index=0&id=4d6feb4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6feb4b",
  null
  
)

export default component.exports